import React, { useState } from 'react';
import { suspendUser } from '../../api/user';
import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';
import {toast} from 'react-toastify'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const reasons = [
  'Personal Data Exposure',
  'Inappropriate Profile Content',
  'Spam or Unsolicited Messages',
  'Inappropriate or Restricted Images',
  'Others',
];

const SuspendCard = ({ userId, suspend, handleClose,fetchData,isBot }) => {
  const [isUpdating, setIsUpdating] = useState(false);
  const [reason, setReason] = useState('');
  const [customReason, setCustomReason] = useState('');

  const handleSuspendUser = async () => {
    if (!userId) return;
    try {
      const suspendReason = reason !== 'Others' ? reason : customReason.trim();

      if (!suspend) {
        if (!suspendReason) {
          toast.error('Please mention the reason.');
          return;
        }

        if (reason === 'Others' && suspendReason.length > 300) {
          toast.error('The other reason must be within 300 characters.');
          return;
        }
      }

      setIsUpdating(true);
      const res = await suspendUser({ userId, suspendReason });
      toast.success(`${isBot ? "Bot" : "User"} suspension status updated successfully`);

      if (res.success) {
        setReason('');
        setCustomReason('');
        handleClose();
        fetchData && fetchData();
      }
    } finally {
      setIsUpdating(false);
    }
  };
  return (
    <div>
      {suspend ? (
        <>
          <h5 className="font-36">Lift Suspension</h5>
          <p>Restore this {isBot ? "bot’s" : "user’s"} access and privileges to the platform.</p>
        </>
      ) : (
        <>
          <h5 className="font-36">Suspend {isBot ? "Bot" : "User"}</h5>
          <p>Track platform actions for enhanced transparency and control.</p>
          <FormControl
            size="small"
            sx={{
              marginBottom: 2,
              width: '100%',
              boxShadow: 'none',
              '& .MuiOutlinedInput-root': {
                borderRadius: '6px',
                boxShadow: 'none',
                '& fieldset': {
                  borderColor: '#d1d5db',
                  borderWidth: '1px',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#2563eb',
                  borderWidth: '1.5px',
                },
              },
            }}
          >
            <Select
              value={reason}
              onChange={(e) => {
                const nextReason = e.target.value;
                setReason(nextReason);
                if (nextReason !== 'Others') {
                  setCustomReason('');
                }
              }}
              displayEmpty
              renderValue={(selectedValue) => {
                if (selectedValue === '') {
                  return <Typography color="textSecondary">Select a reason</Typography>;
                }
                return selectedValue;
              }}
              IconComponent={KeyboardArrowDownIcon}
              sx={{
                borderRadius: '8px',
                fontSize: '14px',
                '& .MuiSelect-select': {
                  padding: '10px 14px',
                },
                '& .MuiSvgIcon-root': {
                  color: '#747474ff',
                  fontSize: '22px',
                },
              }}
            >
              {reasons.map((item) => (
                <MenuItem key={item} value={item} sx={{ fontSize: '14px', fontWeight: 500 }}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {reason === 'Others' && (
            <div className="mb-16">
              <label className="mb-8">Other Reason</label>
              <textarea
                className="form-control"
                maxLength={300}
                placeholder="Write other reason..."
                value={customReason}
                onChange={(e) => setCustomReason(e.target.value)}
              ></textarea>
            </div>
          )}
        </>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}> <button
        className="badge text-md fw-medium bg-warning-900 px-20 py-9 radius-8 text-white"
        onClick={handleSuspendUser}
        disabled={isUpdating || (!suspend && !reason)}
      >
        {' '}
        {isUpdating ? 'Processing...' : 'Confirm'}
      </button>
      </Box>
    </div>
  );
};

export default SuspendCard;
